/**
 * How a subject is identified on screen.
 *
 * Client, 2026-10-16. Two numbers, two names (display only; the stored
 * fields keep their names):
 *   - "Subject ID"           = `ivrf_number`, the subject's number in the
 *     sponsor's IVRS/IWRS (e.g. "USA94-001"). What the sponsor, monitor and
 *     pharmacy quote, so it leads wherever there is one.
 *   - "Subject Reference ID" = `external_ref`, DreamTrials' own automatic
 *     number (e.g. "SUB-0023").
 *
 * The Subject ID is optional: the vendor often has not issued one at
 * screening. Where it is missing, the Subject Reference ID stands in with a
 * "REF-" prefix ("REF-SUB-0040"), so everyone can see it is the internal
 * number and not a Subject ID (client, 16 Oct 2026).
 */
export interface SubjectIdLike {
  external_ref: string;
  ivrf_number?: string | null;
}

export const SUBJECT_ID_LABEL = 'Subject ID';
export const SUBJECT_REFERENCE_ID_LABEL = 'Subject Reference ID';

/** The Subject ID (IVRS), or null when none has been issued yet. */
export function subjectIvrsId(subject: SubjectIdLike): string | null {
  return subject.ivrf_number?.trim() || null;
}

/** The Subject ID, else the internal number marked "REF-SUB-xxxx". */
export function subjectDisplayId(subject: SubjectIdLike): string {
  return subjectIvrsId(subject) ?? `REF-${subject.external_ref}`;
}
